const users = {
    en: {
        "users.title": "Users",
        "users.id": "ID",
        "users.fullname": "Fullname",
        "users.email": "Email",
        "users.username": "Username",
        "users.supFee": "Sup. Fee",
        "users.lastLoginDate": "Last Login Date",
        "users.lastPurchaseDate": "Last Purchase Date",
        "users.role": "Role",
        "users.debt": "Debt",

        "users.removeTitle": "Remove user",
        "users.removeConfirm": "Do you want to remove user?",
        "users.addTitle": "Add New User",
        "users.editTitle": "Modify user data",

        "users.calculatorCategory": "Calculator category",
        "users.superviserFee": "Superviser fee",
        "users.name": "Name",
        "users.surname": "Surname",
        "users.identityNumber": "Identity number",
        "users.phone": "Phone",
        "users.password": "Password",
        "users.confirmPassword": "Confirm Password",

        "users.selectCategory": "Select Category",
        "users.selectRole": "Select Role",
        "users.roleAdmin": "Admin",
        "users.roleModerator": "Moderator",
        "users.roleSuperviser": "Superviser",
        "users.roleDispecher": "Dispecher",
        "users.roleUser": "User",

        "users.phSuperviserFee": "Enter superviser fee",
        "users.phName": "Enter your name",
        "users.phSurname": "Enter your surname",
        "users.phIdentityNumber": "Enter your identity number",
        "users.phPhone": "Enter your phone",
        "users.phEmail": "Enter your email",
        "users.phUsername": "Enter your username",
        "users.phPassword": "Enter your password",
        "users.phConfirmPassword": "Repeat your password",
    },
    ru: {
        "users.title": "Пользователи",
        "users.id": "ID",
        "users.fullname": "ФИО",
        "users.email": "Эл. почта",
        "users.username": "Имя пользователя",
        "users.supFee": "Комиссия",
        "users.lastLoginDate": "Дата последнего входа",
        "users.lastPurchaseDate": "Дата последней покупки",
        "users.role": "Роль",
        "users.debt": "Долг",

        "users.removeTitle": "Удалить пользователя",
        "users.removeConfirm": "Вы действительно хотите удалить пользователя?",
        "users.addTitle": "Добавить пользователя",
        "users.editTitle": "Изменить данные пользователя",

        "users.calculatorCategory": "Категория калькулятора",
        "users.superviserFee": "Комиссия супервайзера",
        "users.name": "Имя",
        "users.surname": "Фамилия",
        "users.identityNumber": "Идентификационный номер",
        "users.phone": "Телефон",
        "users.password": "Пароль",
        "users.confirmPassword": "Подтвердите пароль",

        "users.selectCategory": "Выберите категорию",
        "users.selectRole": "Выберите роль",
        "users.roleAdmin": "Администратор",
        "users.roleModerator": "Модератор",
        "users.roleSuperviser": "Супервайзер",
        "users.roleDispecher": "Диспетчер",
        "users.roleUser": "Пользователь",

        "users.phSuperviserFee": "Введите комиссию",
        "users.phName": "Введите имя",
        "users.phSurname": "Введите фамилию",
        "users.phIdentityNumber": "Введите идентификационный номер",
        "users.phPhone": "Введите телефон",
        "users.phEmail": "Введите эл. почту",
        "users.phUsername": "Введите имя пользователя",
        "users.phPassword": "Введите пароль",
        "users.phConfirmPassword": "Повторите пароль",
    },
    geo: {
        "users.title": "მომხმარებლები",
        "users.id": "ID",
        "users.fullname": "სახელი და გვარი",
        "users.email": "ელ. ფოსტა",
        "users.username": "მომხმარებელი",
        "users.supFee": "საკომისიო",
        "users.lastLoginDate": "ბოლო შესვლის თარიღი",
        "users.lastPurchaseDate": "ბოლო შესყიდვის თარიღი",
        "users.role": "როლი",
        "users.debt": "დავალიანება",

        "users.removeTitle": "მომხმარებლის წაშლა",
        "users.removeConfirm": "გსურთ მომხმარებლის წაშლა?",
        "users.addTitle": "ახალი მომხმარებლის დამატება",
        "users.editTitle": "მომხმარებლის მონაცემების რედაქტირება",

        "users.calculatorCategory": "კალკულატორის კატეგორია",
        "users.superviserFee": "ზედამხედველის საკომისიო",
        "users.name": "სახელი",
        "users.surname": "გვარი",
        "users.identityNumber": "პირადი ნომერი",
        "users.phone": "ტელეფონი",
        "users.password": "პაროლი",
        "users.confirmPassword": "გაიმეორეთ პაროლი",

        "users.selectCategory": "აირჩიეთ კატეგორია",
        "users.selectRole": "აირჩიეთ როლი",
        "users.roleAdmin": "ადმინისტრატორი",
        "users.roleModerator": "მოდერატორი",
        "users.roleSuperviser": "ზედამხედველი",
        "users.roleDispecher": "დისპეტჩერი",
        "users.roleUser": "მომხმარებელი",

        "users.phSuperviserFee": "შეიყვანეთ საკომისიო",
        "users.phName": "შეიყვანეთ სახელი",
        "users.phSurname": "შეიყვანეთ გვარი",
        "users.phIdentityNumber": "შეიყვანეთ პირადი ნომერი",
        "users.phPhone": "შეიყვანეთ ტელეფონი",
        "users.phEmail": "შეიყვანეთ ელ. ფოსტა",
        "users.phUsername": "შეიყვანეთ მომხმარებელი",
        "users.phPassword": "შეიყვანეთ პაროლი",
        "users.phConfirmPassword": "გაიმეორეთ პაროლი",
    },
};

export default users;
